<template>
    <div>
        <div class="container search">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>Market Research Settings</h2>
                        </div>
                        <div class="col-md-6 text-right">
                            <a :href="$laravelRoute('manage')">Back To Admin Panel</a>
                        </div>
                    </div>
                    <form @submit.stop.prevent="onSubmit">
                        <messages :messages="messages"/>
                        <div class="row">
                            <div class="col-md-12 container-search">
                                <div class="form-row mt-2">
                                    <b-form-group class="col-md-2"
                                                  label="Enabled"
                                                  label-for="enabled"
                                                  :state="fieldState('enabled')"
                                                  :invalid-feedback="invalidField('enabled')">
                                        <b-form-checkbox
                                            id="enabled"
                                            v-model="setting.enabled"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                </div>
                                <div class="form-row">
                                    <b-form-group class="col-md-6"
                                                  label="Mileage Minus"
                                                  label-for="mileage_minus"
                                                  :state="fieldState('mileage_minus')"
                                                  :invalid-feedback="invalidField('mileage_minus')"
                                    >
                                        <b-form-input
                                            required
                                            id="mileage_minus"
                                            type="number"
                                            step="1"
                                            v-model="setting.value.mileage_minus"
                                            :state="fieldState('mileage_minus')"
                                            placeholder="Enter number">
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group class="col-md-6"
                                                  label="Mileage Plus"
                                                  label-for="mileage_plus"
                                                  :state="fieldState('mileage_plus')"
                                                  :invalid-feedback="invalidField('mileage_plus')"
                                    >
                                        <b-form-input
                                            required
                                            id="mileage_plus"
                                            type="number"
                                            step="1"
                                            v-model="setting.value.mileage_plus"
                                            :state="fieldState('mileage_plus')"
                                            placeholder="Enter number">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="form-row">
                                    <b-form-group class="col-md-6"
                                                  label="Condition Minus"
                                                  label-for="condition_minus"
                                                  :state="fieldState('condition_minus')"
                                                  :invalid-feedback="invalidField('condition_minus')"
                                    >
                                        <b-form-input
                                            required
                                            id="condition_minus"
                                            type="number"
                                            step="0.5"
                                            v-model="setting.value.condition_minus"
                                            :state="fieldState('condition_minus')"
                                            placeholder="Enter number">
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group class="col-md-6"
                                                  label="Condition Plus"
                                                  label-for="condition_plus"
                                                  :state="fieldState('condition_plus')"
                                                  :invalid-feedback="invalidField('condition_plus')"
                                    >
                                        <b-form-input
                                            required
                                            id="condition_plus"
                                            type="number"
                                            step="0.5"
                                            v-model="setting.value.condition_plus"
                                            :state="fieldState('condition_plus')"
                                            placeholder="Enter number">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="form-row">
                                    <b-form-group class="col-md-6"
                                                  label="Year Minus"
                                                  label-for="year_minus"
                                                  :state="fieldState('year_minus')"
                                                  :invalid-feedback="invalidField('year_minus')"
                                    >
                                        <b-form-input
                                            required
                                            id="year_minus"
                                            type="number"
                                            step="1"
                                            v-model="setting.value.year_minus"
                                            :state="fieldState('year_minus')"
                                            placeholder="Enter number">
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group class="col-md-6"
                                                  label="Year Plus"
                                                  label-for="year_plus"
                                                  :state="fieldState('year_plus')"
                                                  :invalid-feedback="invalidField('year_plus')"
                                    >
                                        <b-form-input
                                            required
                                            id="year_plus"
                                            type="number"
                                            step="1"
                                            v-model="setting.value.year_plus"
                                            :state="fieldState('year_plus')"
                                            placeholder="Enter number">
                                        </b-form-input>
                                    </b-form-group>
                                </div>

                                <div class="form-row mt-2">
                                    <div class="form-group col-md-6">
                                        <b-btn type="submit" class="btn">Save</b-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BootstrapValidation from '../../mixins/bootstrap-validation';
import api from '../../api/api_resource'
import {getExceptionErrorMessage, getHttpValidationErrors} from "../../util/common";

export default {
    name: "MarketResearchParameters",
    mixins: [BootstrapValidation],
    props: {
        heading: {
            type: String,
            default: 'Settings'
        },
    },
    data() {
        return {
            messages: [],
            setting: {
                name: 'market_research_parameters',
                value: {
                    mileage_minus: '',
                    mileage_plus: '',
                    condition_minus: '',
                    condition_plus: '',
                    year_minus: '',
                    year_plus: '',
                },
                enabled: true,
            },
        }
    },

    async mounted() {
        await this.getSetting();
    },

    methods: {
        async getSetting(){
            let res = await this.axios.get(this.$laravelRoute('admin.site-settings.edit-market-research'))
            if (res.data && res.data.setting) {
                this.setting = res.data.setting
            }
        },
        onSubmit() {
            this.messages = []
            this.errors = [];
            api.post('admin.site-settings.save', [], this.setting)
                .then(response => {
                    if (response && response.message) {
                        this.messages.push({type: 'success', message: response.message});
                    }
                }).catch(error => {
                let message = getExceptionErrorMessage(error);
                this.messages.push({type: 'danger', message});
                let errors = getHttpValidationErrors(error);
                if (errors) {
                    this.errors = errors;
                }

            });
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/SiteSettings/MarketResearchParameters.vue